// src/pages/productTypes/CreateProductTypes.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditProductTypes from "../../components/productTypes/FormAddEditProductTypes";

const CreateProductTypes = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProductTypes
                isEdit={false}
                onSubmitSuccess={() => navigate("/product-types")}
            />
        </WrapperSection>
    );
};

export default CreateProductTypes;